// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { initialize } from 'redux-form'
import { loadingToggler } from 'redux/modules/loading'
import CallsignCascade, { modalConfig } from 'components/CallsignCascade'
import { CALLSIGN_CASCADE_FORM } from 'components/CallsignCascade/constants'
import TryAgainForCallsignCascadeMatches from 'components/CallsignCascade/TryAgainForCallsignCascadeMatches'
import { ProjectStatusIdEnum } from 'config/enums'

import reduceCallsignCascadeData from './reduceCallsignCascadeData'

import { postGetCallsignCascades } from 'helpers/api'

const handleCallsignCascadeMatches = (callsignCascadeTriggerData, openContextModal, handleSuccessfulSubmitCallback) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const {
        pathDetails,
        projectSummary,
      } = getState()

      const projectStatusId = projectSummary.getIn(['projectStatus', 'projectStatusId'])
      const withinBulkEdit = pathDetails.get('withinBulkEdit')
      const withinProjectSummary = pathDetails.get('withinProjectSummary')

      if (
        // if the paths are "In Progress", do not allow call sign cascade
        (withinProjectSummary && projectStatusId === ProjectStatusIdEnum.IN_PROGRESS) ||
        // if there is no trigger data, just get outta here!
        callsignCascadeTriggerData === null
      ) {
        return
      }

      try {
        const { entities } = await postGetCallsignCascades(callsignCascadeTriggerData)

        // prepares the data for redux-form
        const {
          callsignCascadeData,
          callsignCascadeInput,
        } = reduceCallsignCascadeData(entities, withinBulkEdit)

        // finally if there are no aggregates with matches to present to the user,
        // then just get outta here and don't show the modal.
        if (callsignCascadeData.length === 0) {
          return
        }

        // initializes the callsign cascade form
        dispatch(initialize(CALLSIGN_CASCADE_FORM, { callsignCascadeInput }))

        // then triggers the modal to display the callsign cascade form.
        openContextModal(
          <CallsignCascade
            callsignCascadeData={callsignCascadeData}
            handleSuccessfulSubmitCallback={handleSuccessfulSubmitCallback} />,
          modalConfig,
        )
      } catch (err) {
        console.warn(err)

        openContextModal(
          <TryAgainForCallsignCascadeMatches
            callsignCascadeTriggerData={callsignCascadeTriggerData}
            errorMessage={err.message} />
        )
      }
    })
  )
)

export default handleCallsignCascadeMatches
